import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import {DateRange} from "components/common/formFields/DateRange";
import {Button, Form} from "react-bootstrap";
import {DropDownSelect, MultiSelectContextMenu} from "components/common";
import {OrganizationDropDownSelect} from "components/Message/OrganizationDropDownSelect";
import styles from "../Styles.module.css";

const dropdownStyles = {
    borderColor: "#c4c9c7",
    boxShadow: "none",
    color: "#5a5f5e",
    width: "100%"
};

class FilterForm extends Component {

    render() {

        const {
            startDate,
            endDate,
            onDatePickerUpdate,
            typeOptions,
            organizationOptions,
            handleOrgFilterChange,
            submitting,
            onFormUpdate,
            checkedOrganizations,
            handleChange,
            onFormSubmit,
            screenshotType,
            organizationIds
        } = this.props;

        const typeInput = {onChange: onFormUpdate, value: screenshotType};
        const companiesInput = {onChange: handleChange};

        return (
            <Form inline onSubmit={onFormSubmit} className="messages-page-filter-form">
                <div>
                    <span className="font-14 color-grey-dark">Date</span>
                    <label className="calendar-today tms-inbox-calendar display-block">
                        <Field
                            submittedStartDate={startDate}
                            submittedEndDate={endDate}
                            id="datePicker"
                            name="datePicker"
                            defaultDateRange="today"
                            onEvent={onDatePickerUpdate}
                            values={startDate}
                            style={dropdownStyles}
                            // placeholder={`${startDate} - ${endDate}`}
                            component={DateRange}
                        />
                    </label>
                </div>

                <div className={styles.typeContainer}>
                    <span className="font-14 color-grey-dark">Type</span>
                    <label className="display-block">
                        <Field
                            name="type"
                            fieldName="type"
                            style={dropdownStyles}
                            input={typeInput}
                            options={typeOptions}
                            value={screenshotType}
                            component={DropDownSelect}
                        />
                    </label>
                </div>

                <div className={styles.mt10}>
                    <span className="font-14 color-grey-dark">Organizations</span>
                    <div className="inbox-context-menu display-block">
                        <Field
                            name="organizations"
                            fieldName="organizations"
                            type="text"
                            displayName={'Organizations'}
                            options={organizationOptions}
                            checkedOptions={checkedOrganizations}
                            ids={organizationIds}
                            handleChange={handleOrgFilterChange}
                            component={MultiSelectContextMenu}
                        />
                    </div>
                </div>

                <div className={styles.mt15}>
                    <Button bsStyle="success" type="submit" disabled={submitting} className={styles.fullWidth}>
                        <i className='fa fa-filter'/> Filter
                    </Button>
                </div>
            </Form>
        )
    }
}

const connectedForm = reduxForm({
    form: 'screenshotFilterForm'
})(FilterForm);

export {connectedForm as ScreenshotFilterForm}
